export default __webpack_public_path__ + "static/media/checkEvent.08dd520d.svg";